/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreatePaymentRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'
import {CreatePaymentResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'


export const createPayment = (request:CreatePaymentRequest, options?: CashRequestOptions) => post<CreatePaymentRequest, CreatePaymentResponse>("/2.0/cash/create-payment", request, {...options, rejectOnError: true })